// extracted by mini-css-extract-plugin
export default {"cls1":"ConfirmationBanner-cls1___5c13063ae607ea64216","cls2":"ConfirmationBanner-cls2___db7c13c016a6072d779 ConfirmationBanner-cls1___5c13063ae607ea64216"};